import React, { useEffect, useState } from "react";
import { Container, Row } from "reactstrap";
import Breadcrumb from "Components/Common/Breadcrumb";
// import Filter from "./Filter";
import Detail from "./Detail";
import Filter from "Components/Common/Filter";

const SwNormalZoneDetailIndex = () => {
  document.title = "Усны хориглолт, хамгаалалтын бүс";

  const [searchField, setSearchField] = useState<any>();

  useEffect(() => {
  }, [searchField])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Гадаргын ус" breadcrumbItem="Усны хориглолт, хамгаалалтын бүс" />
          <Row>
            <Filter
              setSearchField={setSearchField}
              f_name={true}
              f_au1_code={true}
              f_status={true}
              f_decision_no={true}
            />
            <Detail searchField={searchField} />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SwNormalZoneDetailIndex;
